
import { ReactElement, useEffect, useState } from 'react'
import {
    ActionButton,
    DropdownWrapper,
    EditableDropdown,
    FlexWrapper,
    Input,
    PageWrapper,
    SectionTitle
} from '../../../../components'
import strings from '../../../../locale/en'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { getAllCoursesDropdown, getCoursesDropdown } from '../../../../helpers'
import { DropdownListProps } from '../../../../components/EditableDropdown/typings'
import { getAdminList } from '../../../../redux/coachingCenter/api'
import AdminType from '../../../../const/admin'
import { assignSessionlist } from '../../../../redux/learnSession/api'
import { getChildCourses, getCourse } from '../../../../redux/course/api'
import { courseSessionAssignDetail } from '../../../../redux/learnSession/types'
import { formValues, resetInitialValues } from './const'
import { Wrapper } from '../subcomponent'

const AssignLearnSession = (): ReactElement => {
    const {
        courseId,
        courseDetails,
        subjects,
        chapters,
        topics,
    } = useSelector(
        (state: RootState) => ({
            teachers: state.coachingCenter.admin?.adminList,
            courseId: state.learnSession.sessionresponse.courseId,
            courseDetails: state.course.courseDetails,
            subjects: state.course.subjects,
            chapters: state.course.chapters,
            topics: state.course.topics,
        })
    )

    const {
        menu: {
            learnSession: {
                assignSession: {
                    title,
                    chapter,
                    course,
                    topic,
                    subject
                },
                placeholder: {
                    selectChapter,
                    selectCourse,
                    selectSubject,
                    selectTopic,
                }
            }
        }
    } = strings
    const dispatch = useDispatch()
    const courseList = courseDetails ? getAllCoursesDropdown(courseDetails) : []
    const subjectList = subjects ? getCoursesDropdown(subjects) : []
    const chapterList = chapters ? getCoursesDropdown(chapters) : []
    const topicList = topics ? getCoursesDropdown(topics) : []

    const [values, setValues] = useState<Array<courseSessionAssignDetail>>([])
    const [formValues, setFormValues] = useState<formValues>({} as formValues)
    const [resetValues, setResetValues] = useState(resetInitialValues)

    const addFormfields = () => {
        setValues([
            ...values,
            { ...formValues },
        ]);
        setFormValues({} as formValues);
        clearValues()
    };

    const clearValues = () => {
        setResetValues({
            course: true,
            chapter: true,
            topic: true,
            subject: true
        })
        setFormValues({} as formValues)
    }

    useEffect(() => {
        dispatch(getAdminList({ type: AdminType.TEACHER }))
        dispatch(getCourse())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    console.log(values);
    console.log(formValues);


    return (
        <PageWrapper>
            <FlexWrapper hasBorder>
                <SectionTitle title={title} />
            </FlexWrapper>

            {values?.map((element, index) => (
                <Wrapper key={index}   >
                    <DropdownWrapper>
                        <Input
                            value={element?.course}
                            height="45px"
                        />
                    </DropdownWrapper>
                    <DropdownWrapper  >
                        <Input
                            height="45px"
                            value={element?.subject}
                        />
                    </DropdownWrapper>
                    <DropdownWrapper  >
                        <Input
                            height="45px"
                            value={element?.chapter}
                        />
                    </DropdownWrapper>
                    <DropdownWrapper>
                        <Input
                            height="45px"
                            value={element?.topic}
                        />
                    </DropdownWrapper>
                </Wrapper>
            ))}
            <FlexWrapper>
                <DropdownWrapper>
                    <EditableDropdown
                        dropdownList={courseList}
                        placeholder={selectCourse}
                        title={course}
                        isRequired
                        handleSelect={(value: DropdownListProps) => {
                            dispatch(getChildCourses(
                                {
                                    courseId: value?.id,
                                    type: 'SUBJECT'
                                }
                            ))
                            setFormValues({
                                ...formValues,
                                course: value?.name
                            })
                            setResetValues({
                                ...resetInitialValues,
                                chapter: true,
                                subject: true,
                                topic: true
                            })
                        }}
                        reset={resetValues?.course}
                    />
                </DropdownWrapper>
                <DropdownWrapper>
                    <EditableDropdown
                        dropdownList={subjectList}
                        placeholder={selectSubject}
                        title={subject}
                        isRequired
                        handleSelect={(value: DropdownListProps) => {
                            dispatch(getChildCourses(
                                {
                                    courseId: value?.id,
                                    type: 'CHAPTER'
                                }
                            ))
                            setFormValues({
                                ...formValues,
                                subject: value?.name
                            })
                            setResetValues({
                                ...resetInitialValues,
                                subject: true,
                                topic: true
                            })
                        }}
                        reset={resetValues?.subject}
                    />
                </DropdownWrapper>
                <DropdownWrapper>
                    <EditableDropdown
                        dropdownList={chapterList}
                        placeholder={selectChapter}
                        title={chapter}
                        isRequired
                        handleSelect={(value: DropdownListProps) => {
                            dispatch(getChildCourses(
                                {
                                    courseId: value?.id,
                                    type: 'TOPIC'
                                }
                            ))
                            setFormValues({
                                ...formValues,
                                chapter: value?.name
                            })
                            setResetValues({
                                ...resetInitialValues,
                                topic: true
                            })
                        }}
                        reset={resetValues?.chapter}
                    />
                </DropdownWrapper>
                <DropdownWrapper>
                    <EditableDropdown
                        dropdownList={topicList}
                        placeholder={selectTopic}
                        title={topic}
                        isRequired
                        handleSelect={(value: DropdownListProps) => {
                            setFormValues({
                                ...formValues,
                                topic: value?.name
                            })
                            setResetValues({
                                ...resetInitialValues,
                            })
                        }}
                        reset={resetValues?.topic}
                    />
                </DropdownWrapper>
            </FlexWrapper>
            <FlexWrapper justifyContent='center' noPadding>
                <ActionButton
                    onClick={() => {
                        dispatch(assignSessionlist({
                            id: courseId,
                            courseSessionDetailDao: [...values, {
                                ...formValues
                            }]
                        }))
                    }}
                >
                    Submit
                </ActionButton>
                <ActionButton onClick={addFormfields}>Add More Course</ActionButton>
            </FlexWrapper>
        </PageWrapper >
    )
}

export default AssignLearnSession